import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';

@Injectable()
export class HttpEffects {
  constructor(private readonly actions$: Actions) {}
}
